var _style, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWaste = function SvgWaste(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "waste_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 550.35 550.35",
    style: {
      enableBackground: "new 0 0 550.35 550.35"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".waste_svg__st1{fill:#00ff52}")), /*#__PURE__*/React.createElement("circle", {
    cx: 275.17,
    cy: 275.17,
    r: 275.17,
    style: {
      fill: "#e5e5e5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "waste_svg__st1",
    d: "M144.4 215.09h261.54v45.09H144.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.94 270.18H144.4c-5.52 0-10-4.48-10-10v-45.09c0-5.52 4.48-10 10-10h261.54c5.52 0 10 4.48 10 10v45.09c0 5.53-4.47 10-10 10zm-251.54-20h241.54v-25.09H154.4v25.09z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "waste_svg__st1",
    d: "M361.8 448.94H188.55l-25.79-187.87h224.83z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M361.8 458.94H188.55c-5 0-9.23-3.69-9.91-8.64l-25.79-187.86a10.002 10.002 0 0 1 9.91-11.36h224.82a10.002 10.002 0 0 1 9.91 11.36L371.71 450.3a10.01 10.01 0 0 1-9.91 8.64zm-164.53-20h155.81l23.04-167.86H174.23l23.04 167.86z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M228.21 423.01c-5.52 0-10-4.48-10-10V297c0-5.52 4.48-10 10-10s10 4.48 10 10v116.01c0 5.53-4.48 10-10 10zM275.17 423.01c-5.52 0-10-4.48-10-10V297c0-5.52 4.48-10 10-10s10 4.48 10 10v116.01c0 5.53-4.47 10-10 10zM322.14 423.01c-5.52 0-10-4.48-10-10V297c0-5.52 4.48-10 10-10s10 4.48 10 10v116.01c0 5.53-4.48 10-10 10zM314.96 178.2c-2.56 0-5.12-.98-7.07-2.93l-79.56-79.56c-3.9-3.91-3.9-10.24 0-14.14 3.91-3.91 10.24-3.91 14.14 0l79.56 79.56c3.91 3.91 3.91 10.24 0 14.14a9.99 9.99 0 0 1-7.07 2.93z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M235.39 178.2c-2.56 0-5.12-.98-7.07-2.93-3.9-3.91-3.9-10.24 0-14.14l79.56-79.56c3.91-3.91 10.24-3.91 14.14 0 3.91 3.91 3.91 10.24 0 14.14l-79.56 79.56a9.973 9.973 0 0 1-7.07 2.93z"
  })));
};

export default SvgWaste;